import React from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'

const RenotifyClient = ({ readOnly, task, refetch }) => {
  const { formatMessage } = useIntl()

  const onClick = () => {
    if (confirm(formatMessage(messages.renotifyClientConfirm))) {
      fetch(`/ordertask/renotifyCustomer.html?taskId=${task.uid}`, { 
          method: 'POST'
        }) 
        .then((response) => response.text())
        .then((response) => {
          if (response !== 'OK') {
            toastr.error(formatMessage(messages.renotifyClientError))
          } else {
            toastr.success(formatMessage(messages.renotifyClientSuccess))
          }
        })
        .catch((error) => toastr.error(error))
        .finally(() => {refetch()})
    }
  }

  return (
    <Menu.Item key='renotifyClient' disabled={readOnly}>
      {(props) => (
        <MenuButton disabled={readOnly} {...props} onClick={onClick}>
          { formatMessage(messages.renotifyClient) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default RenotifyClient
